export type StaffLanguage = "en" | "am";

// Exact static UI phrases only. API/database values are deliberately not translated.
export const amharic: Record<string, string> = {
  English: "English",
  Amharic: "አማርኛ",
  Language: "ቋንቋ",
  "Switch language": "ቋንቋ ቀይር",
  Dashboard: "ዳሽቦርድ",
  Jobs: "ሥራዎች",
  Vacancies: "ክፍት የሥራ ቦታዎች",
  "Job Applications": "የሥራ ማመልከቻዎች",
  "CRM Leads": "የCRM ደንበኞች",
  Bids: "ጨረታዎች",
  Roster: "የሥራ ፈረቃ",
  Employees: "ሠራተኞች",
  Attendance: "የሥራ መገኘት",
  "Clients & Sites": "ደንበኞች እና ሳይቶች",
  Assets: "ንብረቶች",
  Payroll: "ደመወዝ",
  Billing: "ክፍያ እና ደረሰኝ",
  Incidents: "ክስተቶች",
  Reports: "ሪፖርቶች",
  "User & role management": "ተጠቃሚና ሚና አስተዳደር",
  "Attendance Settings": "የመገኘት ቅንብሮች",
  Logout: "ውጣ",
  "Log out": "ውጣ",
  Profile: "መገለጫ",
  "User management": "ተጠቃሚ አስተዳደር",
  "Toggle menu": "ምናሌ ክፈት/ዝጋ",
  Notifications: "ማሳወቂያዎች",
  "Search sites...": "ሳይቶችን ፈልግ...",
  Search: "ፈልግ",
  "Search...": "ፈልግ...",
  Filter: "አጣራ",
  All: "ሁሉም",
  "All sites": "ሁሉም ሳይቶች",
  "All Sites": "ሁሉም ሳይቶች",
  "All statuses": "ሁሉም ሁኔታዎች",
  "All Status": "ሁሉም ሁኔታዎች",
  "All categories": "ሁሉም ምድቦች",
  "All companies": "ሁሉም ድርጅቶች",
  Actions: "ድርጊቶች",
  Action: "ድርጊት",
  Details: "ዝርዝር",
  Edit: "አርትዕ",
  Delete: "ሰርዝ",
  Remove: "አስወግድ",
  Create: "ፍጠር",
  Add: "ጨምር",
  Save: "አስቀምጥ",
  "Save Changes": "ለውጦችን አስቀምጥ",
  Update: "አዘምን",
  Cancel: "ሰርዝ",
  Close: "ዝጋ",
  Confirm: "አረጋግጥ",
  Submit: "አስገባ",
  Download: "አውርድ",
  View: "ተመልከት",
  Export: "ወደ ፋይል ላክ",
  Print: "አትም",
  Previous: "ቀዳሚ",
  Next: "ቀጣይ",
  "Loading...": "በመጫን ላይ...",
  "Loading…": "በመጫን ላይ…",
  "No results.": "ውጤት የለም።",
  Required: "አስፈላጊ",
  Optional: "አማራጭ",
  Yes: "አዎ",
  No: "አይ",
  Active: "ንቁ",
  Inactive: "የቦዘነ",
  Available: "ዝግጁ",
  Assigned: "የተመደበ",
  Pending: "በመጠባበቅ ላይ",
  Completed: "ተጠናቋል",
  Cancelled: "ተሰርዟል",
  Draft: "ረቂቅ",
  Paid: "ተከፍሏል",
  Overdue: "ጊዜው ያለፈ",
  Due: "የሚከፈል",
  Verified: "የተረጋገጠ",
  Failed: "አልተሳካም",
  Present: "ተገኝቷል",
  Absent: "ቀርቷል",
  Late: "ዘግይቷል",
  Early: "ቀድሞ",
  "On Time": "በሰዓቱ",
  Normal: "መደበኛ",
  Critical: "አስጊ",
  High: "ከፍተኛ",
  Medium: "መካከለኛ",
  Low: "ዝቅተኛ",
  Status: "ሁኔታ",
  Category: "ምድብ",
  Company: "ድርጅት",
  Client: "ደንበኛ",
  Site: "ሳይት",
  Employee: "ሠራተኛ",
  "Field Staff": "የመስክ ሠራተኛ",
  Name: "ስም",
  "First Name": "የመጀመሪያ ስም",
  "Last Name": "የአባት ስም",
  Username: "የተጠቃሚ ስም",
  Email: "ኢሜይል",
  Phone: "ስልክ",
  "Phone Number": "ስልክ ቁጥር",
  Address: "አድራሻ",
  Description: "መግለጫ",
  Notes: "ማስታወሻ",
  Date: "ቀን",
  "Start Date": "መጀመሪያ ቀን",
  "End Date": "መጨረሻ ቀን",
  "Start Time": "መጀመሪያ ሰዓት",
  "End Time": "መጨረሻ ሰዓት",
  "Date Range": "የቀን ክልል",
  Amount: "መጠን",
  Value: "ዋጋ",
  Total: "ጠቅላላ",
  Code: "ኮድ",
  Reference: "ማጣቀሻ",
  Condition: "ሁኔታ",
  Documents: "ሰነዶች",
  Attachments: "አባሪዎች",
  File: "ፋይል",
  "File name": "የፋይል ስም",
  "Choose file": "ፋይል ምረጥ",
  Upload: "ስቀል",
  "Already uploaded": "አስቀድሞ የተሰቀለ",
  Password: "የይለፍ ቃል",
  "Current Password": "የአሁኑ የይለፍ ቃል",
  "New Password": "አዲስ የይለፍ ቃል",
  "Confirm Password": "የይለፍ ቃል አረጋግጥ",
  "Change Password": "የይለፍ ቃል ቀይር",
  Role: "ሚና",
  "Last Login": "የመጨረሻ መግቢያ",
  Permissions: "ፈቃዶች",
  Overview: "አጠቃላይ",
  Finance: "ፋይናንስ",
  "Finance Report": "የፋይናንስ ሪፖርት",
  "Attendance Report": "የመገኘት ሪፖርት",
  "Advanced Reports": "የላቀ ሪፖርቶች",
  "Analytics and exports for the current month": "የወሩ ትንታኔ እና የሚወርዱ ሪፖርቶች",
  "Total Billed": "ጠቅላላ የተከፈለ",
  Collected: "የተሰበሰበ",
  "Attendance Status": "የመገኘት ሁኔታ",
  "Incident Severity": "የክስተት ክብደት",
  "Assets by Company": "ንብረቶች በድርጅት",
  "Assets by Category": "ንብረቶች በምድብ",
  "Full Asset Inventory": "ሙሉ የንብረት ዝርዝር",
  "Assignment and Return History": "የምደባና የመመለስ ታሪክ",
  "Clients, Sites and Payments": "ደንበኞች፣ ሳይቶች እና ክፍያዎች",
  "Client Payment Summary": "የደንበኛ ክፍያ ማጠቃለያ",
  "Site Staffing Detail": "የሳይት ሠራተኛ ዝርዝር",
  "Invoice and Payment Detail": "የደረሰኝና ክፍያ ዝርዝር",
  CRM: "CRM",
  "CRM Performance Report": "የCRM አፈጻጸም ሪፖርት",
  "Lead Pipeline": "የደንበኛ እድል ሂደት",
  "Contract Status": "የውል ሁኔታ",
  "Issue Status": "የጉዳይ ሁኔታ",
  "Lead Detail": "የደንበኛ እድል ዝርዝር",
  "Contract Detail": "የውል ዝርዝር",
  "Customer Issues": "የደንበኛ ጉዳዮች",
  "Bid Performance Report": "የጨረታ አፈጻጸም ሪፖርት",
  "Bids by Status": "ጨረታዎች በሁኔታ",
  "Bids by Category": "ጨረታዎች በምድብ",
  "Monthly Bid Activity": "ወርሃዊ የጨረታ እንቅስቃሴ",
  "Complete Bid Detail": "ሙሉ የጨረታ ዝርዝር",
  Potential: "እምቅ",
  Applied: "የተመለከተ",
  Won: "ያሸነፈ",
  Lost: "የተሸነፈ",
  "Not Eligible": "ብቁ ያልሆነ",
  "Win Rate %": "የማሸነፍ መጠን %",
  "Active Employees": "ንቁ ሠራተኞች",
  "Active Jobs": "ንቁ ሥራዎች",
  "Total Assets": "ጠቅላላ ንብረቶች",
  "Open Incidents": "ክፍት ክስተቶች",
  "Add New Client": "አዲስ ደንበኛ ጨምር",
  "Add New Site": "አዲስ ሳይት ጨምር",
  "Add New Asset": "አዲስ ንብረት ጨምር",
  "Create New Vacancy": "አዲስ ክፍት የሥራ ቦታ ፍጠር",
  "Create New Application": "አዲስ ማመልከቻ ፍጠር",
  "New Bid": "አዲስ ጨረታ",
  "Edit Bid": "ጨረታ አርትዕ",
  "Create New Invoice": "አዲስ ደረሰኝ ፍጠር",
  "Create Payroll Period": "የደመወዝ ጊዜ ፍጠር",
  "Generate Payroll": "ደመወዝ አስላ",
  "Company Name": "የድርጅት ስም",
  "Contact Person": "ተጠሪ ሰው",
  "Contact Phone": "የተጠሪ ስልክ",
  "Billing Cycle": "የክፍያ ዙር",
  "Site Name": "የሳይት ስም",
  "GPS Radius (meters)": "የGPS ራዲየስ (ሜትር)",
  Latitude: "ኬክሮስ",
  Longitude: "ኬንትሮስ",
  "Asset Code": "የንብረት ኮድ",
  "Asset Name": "የንብረት ስም",
  "Purchase Date": "የግዢ ቀን",
  "Assign Asset": "ንብረት መድብ",
  "Return Asset": "ንብረት መልስ",
  "Clock In": "መግቢያ መዝግብ",
  "Clock Out": "መውጫ መዝግብ",
  "Clock-in Time": "የመግቢያ ሰዓት",
  "Clock-out Time": "የመውጫ ሰዓት",
  "Field Staff GPS Attendance": "የመስክ ሠራተኛ GPS መገኘት",
  "Manual Entry": "በእጅ ማስገባት",
  "Excel Import": "ከExcel ማስገባት",
  "Job Title": "የሥራ መደብ",
  Education: "ትምህርት",
  Experience: "ልምድ",
  Age: "ዕድሜ",
  Sex: "ጾታ",
  Male: "ወንድ",
  Female: "ሴት",
  CV: "ሲቪ",
  "Base Salary": "መሠረታዊ ደመወዝ",
  Bonuses: "ጉርሻዎች",
  Deductions: "ቅናሾች",
  "Net Salary": "የተጣራ ደመወዝ",
  "Invoice Items": "የደረሰኝ ዝርዝሮች",
  "Incident Report": "የክስተት ሪፖርት",
  Severity: "ክብደት",
  Evidence: "ማስረጃ",
  "Reported By": "ሪፖርት ያደረገው",
  "Reported At": "ሪፖርት የተደረገበት",
  Settings: "ቅንብሮች",
  "Personal Information": "የግል መረጃ",
  "Account Settings": "የመለያ ቅንብሮች",
  Security: "ደህንነት",
  POTENTIAL: "እምቅ",
  APPLIED: "የተመለከተ",
  WON: "ያሸነፈ",
  LOST: "የተሸነፈ",
  NOT_ELIGIBLE: "ብቁ ያልሆነ",
  REACH: "የመጀመሪያ ግንኙነት",
  QUALIFIED: "ብቁ",
  PROPOSAL: "ፕሮፖዛል",
  NEGOTIATION: "ድርድር",
  CLOSED_WON: "በስኬት ተዘግቷል",
  CLOSED_LOST: "ሳይሳካ ተዘግቷል",
  OPEN: "ክፍት",
  IN_PROGRESS: "በሂደት ላይ",
  RESOLVED: "መፍትሔ አግኝቷል",
  CLOSED: "ተዘግቷል",
  ACTIVE: "ንቁ",
  EXPIRED: "ጊዜው ያለፈ",
  TERMINATED: "የተቋረጠ",
};

Object.assign(amharic, {
  // Dashboard and shared tables
  "Assets in Use": "በጥቅም ላይ ያሉ ንብረቶች",
  "Attendance Today": "የዛሬ መገኘት",
  "Recent Activity": "የቅርብ ጊዜ እንቅስቃሴ",
  "Live Map": "ቀጥታ ካርታ",
  "Upcoming Roster": "መጪ የሥራ ፈረቃ",
  "Attendance Trend (Last 7 Days)": "የመገኘት አዝማሚያ (ያለፉት 7 ቀናት)",
  "Asset Availability Chart": "የንብረት ዝግጁነት ገበታ",
  "Asset Availability by Category": "የንብረት ዝግጁነት በምድብ",
  "Recent Bonuses": "የቅርብ ጊዜ ጉርሻዎች",
  "Recent Penalties": "የቅርብ ጊዜ ቅጣቶች",
  "No upcoming shifts scheduled": "የታቀደ መጪ ፈረቃ የለም",
  "Map view coming soon": "የካርታ እይታ በቅርቡ ይመጣል",
  "Rows per page": "በአንድ ገጽ ያሉ ረድፎች",
  Columns: "ዓምዶች",
  Page: "ገጽ",
  of: "ከ",
  "No results": "ውጤት የለም",
  Manage: "አስተዳድር",
  Overall: "አጠቃላይ",
  "N/A": "የለም",

  // Assets
  Asset: "ንብረት",
  "Asset Details": "የንብረት ዝርዝር",
  "Assets by Company and Product": "ንብረቶች በድርጅትና በምርት",
  "All Assignment History": "ሙሉ የምደባ ታሪክ",
  "Assignment History": "የምደባ ታሪክ",
  "Current Assignment": "የአሁኑ ምደባ",
  "Assignment period": "የምደባ ጊዜ",
  "Assigned To": "የተመደበለት",
  "Assigned site": "የተመደበ ሳይት",
  "Return Condition": "የመመለሻ ሁኔታ",
  "Currently assigned": "አሁን የተመደበ",
  Good: "ጥሩ",
  Damaged: "የተጎዳ",
  Maintenance: "ጥገና ላይ",
  New: "አዲስ",
  Equipment: "መሣሪያ",
  Uniform: "ዩኒፎርም",
  Vehicle: "ተሽከርካሪ",
  Product: "ምርት",
  Quantity: "ብዛት",
  Price: "ዋጋ",
  "Unit Price": "የአንድ ዋጋ",
  "Purchase Date": "የግዢ ቀን",
  "No company": "ድርጅት የለም",
  "No asset categories available": "የንብረት ምድብ የለም",
  "Loading assets...": "ንብረቶች በመጫን ላይ...",
  "Loading batches...": "ቡድኖች በመጫን ላይ...",
  "Error loading asset data": "የንብረት መረጃ መጫን አልተሳካም",
  "The same product from the same company is shown once. Open it to manage every individual unit.":
    "ከአንድ ድርጅት የመጣ ተመሳሳይ ምርት አንድ ጊዜ ብቻ ይታያል። እያንዳንዱን ለማስተዳደር ይክፈቱት።",

  // Attendance and roster
  "Attendance Details": "የመገኘት ዝርዝር",
  "Attendance Mode": "የመገኘት ሁነታ",
  "Clock-in/out records": "የመግቢያ/መውጫ መዝገቦች",
  "Clock-in image": "የመግቢያ ፎቶ",
  "Clock-out image": "የመውጫ ፎቶ",
  "Verification Images": "የማረጋገጫ ምስሎች",
  Verification: "ማረጋገጫ",
  "Verification:": "ማረጋገጫ፦",
  Device: "መሣሪያ",
  Hours: "ሰዓታት",
  "Worked Days": "የሠራባቸው ቀናት",
  "Expected Days": "የሚጠበቁ ቀናት",
  "Arrived late": "ዘግይቶ ደርሷል",
  "Left early": "ቀድሞ ወጥቷል",
  "Currently working": "አሁን በሥራ ላይ",
  "Not finished": "አልተጠናቀቀም",
  "On time & complete": "በሰዓቱ እና የተጠናቀቀ",
  Attended: "ተገኝቷል",
  "Absent (Normal)": "ቀሪ (መደበኛ)",
  "Absent (With Permission)": "ቀሪ (በፈቃድ)",
  "Late (Normal)": "ዘግይቷል (መደበኛ)",
  "Late (With Permission)": "ዘግይቷል (በፈቃድ)",
  "Policy Violation": "የደንብ ጥሰት",
  "Unauthorized Absence": "ያለፈቃድ ቀሪ",
  Observation: "ምልከታ",
  "Reason / Note": "ምክንያት / ማስታወሻ",
  "For absence with permission": "በፈቃድ ለቀረ",
  "For late with permission": "በፈቃድ ለዘገየ",
  "Permission Absent Penalty": "የፈቃድ ቀሪ ቅጣት",
  "Permission Late Penalty": "የፈቃድ ዘግይት ቅጣት",
  "Manual Attendance": "በእጅ የመገኘት መዝገብ",
  "Manual Entry": "በእጅ ማስገቢያ",
  "Bulk attendance from Excel": "ከExcel በጅምላ መገኘት ማስገባት",
  "Import Attendance from Excel": "የመገኘት መረጃን ከExcel አስገባ",
  "Row-by-row processing report": "የእያንዳንዱ ረድፍ ሂደት ሪፖርት",
  "Excel Row": "የExcel ረድፍ",
  "Import failed": "ማስገባት አልተሳካም",
  "Schedule Field Staff": "የመስክ ሠራተኛ ፈረቃ አዘጋጅ",
  "Bulk Assign Shifts": "ፈረቃዎችን በጅምላ መድብ",
  Shifts: "ፈረቃዎች",
  "Shift Time": "የፈረቃ ሰዓት",
  "Working Days & Hours Schedule": "የሥራ ቀናትና ሰዓታት መርሃ ግብ",
  "Default Start Time": "ነባሪ መጀመሪያ ሰዓት",
  "Default End Time": "ነባሪ መጨረሻ ሰዓት",
  "Day off": "የዕረፍት ቀን",
  "Ethiopian (EC)": "ኢትዮጵያዊ (ዓ.ም.)",
  "Gregorian (GC)": "ጎርጎርዮሳዊ",
  "Start time (Addis Ababa)": "መጀመሪያ ሰዓት (አዲስ አበባ)",
  "Roster Report": "የፈረቃ ሪፖርት",
  "Detailed shift schedule data": "ዝርዝር የፈረቃ መረጃ",

  // Clients, sites, CRM and bids
  "Customer Relationship Management": "የደንበኛ ግንኙነት አስተዳደር",
  "Prospective Lead Pipeline": "የእምቅ ደንበኞች ሂደት",
  "New Activity": "አዲስ እንቅስቃሴ",
  "Next Action Date": "ቀጣይ ድርጊት ቀን",
  Source: "ምንጭ",
  "Probability (%)": "የመሳካት ዕድል (%)",
  "Expected Value (ETB)": "የሚጠበቅ ዋጋ (ብር)",
  Issuer: "አውጪ አካል",
  "Submission Deadline": "የማስገቢያ ጊዜ ገደብ",
  "Submitted At": "የቀረበበት ቀን",
  "Submitted Value (ETB)": "የቀረበ ዋጋ (ብር)",
  "Result Date": "የውጤት ቀን",
  "Related Client": "ተያያዥ ደንበኛ",
  "Related Site": "ተያያዥ ሳይት",
  "Named Bid Documents": "ስም ያላቸው የጨረታ ሰነዶች",
  "Bid Category": "የጨረታ ምድብ",
  "Client Contracts & CRM": "የደንበኛ ውሎች እና CRM",
  "Customer Issues & Actions": "የደንበኛ ጉዳዮችና እርምጃዎች",
  "Manage Service Categories": "የአገልግሎት ምድቦችን አስተዳድር",
  "Service categories": "የአገልግሎት ምድቦች",
  Services: "አገልግሎቶች",
  Contract: "ውል",
  "Contract Detail": "የውል ዝርዝር",
  Expiry: "የማብቂያ ጊዜ",
  Terminated: "የተቋረጠ",
  "No expiry": "የማብቂያ ጊዜ የለም",
  "Save Contract": "ውል አስቀምጥ",
  "Submit Customer Issue": "የደንበኛ ጉዳይ አስገባ",
  "Submit Issue": "ጉዳይ አስገባ",
  "Record a client concern, priority and required follow-up.":
    "የደንበኛን ቅሬታ፣ ቅድሚያና ተከታታይ እርምጃ ይመዝግቡ።",
  "Manage contract details and securely attach supporting documents.":
    "የውል ዝርዝርን ያስተዳድሩ እና ደጋፊ ሰነዶችን በደህንነት ያያይዙ።",
  "Site Staffing Detail": "የሳይት ሠራተኛ ዝርዝር",
  "Staffing by Site": "ሠራተኞች በሳይት",
  "Primary Site": "ዋና ሳይት",
  "Assigned Sites": "የተመደቡ ሳይቶች",
  "Field Staff / Site Supervisors": "የመስክ ሠራተኞች / የሳይት ተቆጣጣሪዎች",
  "Field Staff assigned to this site (multiple)":
    "ለዚህ ሳይት የተመደቡ የመስክ ሠራተኞች (ብዙ)",

  // Jobs, vacancies and applications
  Job: "ሥራ",
  "Job Categories": "የሥራ ምድቦች",
  "Job Application Management": "የሥራ ማመልከቻ አስተዳደር",
  "Vacancy Management": "ክፍት የሥራ ቦታ አስተዳደር",
  "Job Name": "የሥራ ስም",
  "Job Type": "የሥራ ዓይነት",
  "Job Description / Requirements": "የሥራ መግለጫ / መስፈርቶች",
  "Job Requirements": "የሥራ መስፈርቶች",
  "Candidate Qualification": "የእጩ ብቃት",
  "Positions Needed": "የሚፈለጉ የሥራ ቦታዎች",
  "Number of Employees": "የሠራተኞች ብዛት",
  "Applying For": "የሚያመለክትበት ሥራ",
  "Applying for which job(s)": "ለየትኛው ሥራ ያመለክታል",
  "Related vacancy": "ተያያዥ ክፍት የሥራ ቦታ",
  Qualification: "ብቃት",
  "Current Skills": "የአሁኑ ክህሎቶች",
  "Practical Exam": "የተግባር ፈተና",
  "Written Exam": "የጽሑፍ ፈተና",
  Interview: "ቃለ መጠይቅ",
  "Interview Passed?": "ቃለ መጠይቁን አልፏል?",
  "Overall Result": "አጠቃላይ ውጤት",
  "Screening Date": "የማጣሪያ ቀን",
  "Decision:": "ውሳኔ፦",
  Passed: "አልፏል",
  Retired: "ጡረታ የወጣ",
  "No CV uploaded": "ሲቪ አልተሰቀለም",
  "More Information": "ተጨማሪ መረጃ",
  Positions: "የሥራ ቦታዎች",
  "Total Jobs": "ጠቅላላ ሥራዎች",
  "Hourly Jobs": "የሰዓት ሥራዎች",
  "Monthly Jobs": "ወርሃዊ ሥራዎች",
  "Hourly Rate": "የሰዓት ክፍያ",
  "Pay Type": "የክፍያ ዓይነት",
  Hourly: "በሰዓት",
  Monthly: "ወርሃዊ",
  Annually: "ዓመታዊ",
  Quarterly: "ሩብ ዓመታዊ",

  // Employees, payroll and billing
  "Employee ID": "የሠራተኛ መለያ",
  "Hire Date": "የቅጥር ቀን",
  "Add Employee": "ሠራተኛ ጨምር",
  "Create New Employee": "አዲስ ሠራተኛ ፍጠር",
  "Edit Employee": "የሠራተኛ መረጃ አርትዕ",
  "Employee Category": "የሠራተኛ ምድብ",
  "Assigned Jobs": "የተመደቡ ሥራዎች",
  "None": "ያልተመደበ",
  "None (default)": "ያልተመደበ (ነባሪ)",
  "None / Unassigned": "ያልተመደበ",
  "Clear Filters": "ማጣሪያዎችን አጽዳ",
  "No employees found": "ምንም ሠራተኛ አልተገኘም",
  "Loading category and job filters...": "የምድብና የሥራ ማጣሪያዎች በመጫን ላይ...",
  "Categories come from Jobs → Manage Categories.": "ምድቦች ከሥራዎች → ምድቦችን አስተዳድር ይመጣሉ።",
  "Loading categories...": "ምድቦች በመጫን ላይ...",
  "Search by name, ID, email, or phone...": "በስም፣ መለያ፣ ኢሜይል ወይም ስልክ ፈልግ...",
  "Employee records could not be loaded. Please try again.": "የሠራተኛ መዝገቦች ሊጫኑ አልቻሉም። እንደገና ይሞክሩ።",
  "Manage your workforce and employee information": "የሠራተኞችዎን እና መረጃቸውን ያስተዳድሩ",
  "Add a new employee to the system": "አዲስ ሠራተኛ ወደ ሥርዓቱ ያክሉ",
  "Update employee information and assignments": "የሠራተኛ መረጃና ምደባዎችን ያዘምኑ",
  "Jobs & Pay": "ሥራዎች እና ክፍያ",
  "Employee Login Credentials": "የሠራተኛ መግቢያ መረጃ",
  "Employee Documents": "የሠራተኛ ሰነዶች",
  "Document Name / Description": "የሰነድ ስም / መግለጫ",
  "Document Type": "የሰነድ ዓይነት",
  "Salary Summary": "የደመወዝ ማጠቃለያ",
  "Salary History": "የደመወዝ ታሪክ",
  "Payroll History": "የደመወዝ ክፍያ ታሪክ",
  Earnings: "ገቢዎች",
  Gross: "ጠቅላላ",
  "Net Pay": "የተጣራ ክፍያ",
  "Total Gross": "ጠቅላላ ገቢ",
  "Total Deductions": "ጠቅላላ ቅናሽ",
  "Income Tax": "የገቢ ግብር",
  Pension: "ጡረታ",
  "Pension Contribution": "የጡረታ መዋጮ",
  Tax: "ግብር",
  Commission: "ኮሚሽን",
  "Agency Fee": "የኤጀንሲ ክፍያ",
  "Shift Pay": "የፈረቃ ክፍያ",
  "Bonuses & Adjustments": "ጉርሻዎችና ማስተካከያዎች",
  "Employee Bonuses": "የሠራተኛ ጉርሻዎች",
  "Employee Penalties": "የሠራተኛ ቅጣቶች",
  "Manual Penalties & Adjustments": "በእጅ ቅጣቶችና ማስተካከያዎች",
  "Add Employee Bonus": "የሠራተኛ ጉርሻ ጨምር",
  "Add Penalty": "ቅጣት ጨምር",
  Adjustment: "ማስተካከያ",
  "Adjustment Amount": "የማስተካከያ መጠን",
  "Adjustment Date": "የማስተካከያ ቀን",
  "Salary Adjustment": "የደመወዝ ማስተካከያ",
  "Performance Bonus": "የአፈጻጸም ጉርሻ",
  "Holiday Bonus": "የበዓል ጉርሻ",
  "One-Time Bonus": "የአንድ ጊዜ ጉርሻ",
  "Absent Penalty": "የቀሪ ቅጣት",
  "Late Penalty": "የዘግይት ቅጣት",
  "Asset Damage": "የንብረት ጉዳት",
  Misconduct: "የሥነ ምግባር ጥሰት",
  "Payroll period details and payslips": "የደመወዝ ጊዜ ዝርዝርና የክፍያ ወረቀቶች",
  "Process payroll, manage bonuses, and generate payslips":
    "ደመወዝ ያስሉ፣ ጉርሻዎችን ያስተዳድሩ እና የክፍያ ወረቀት ያዘጋጁ",
  "Invoice #": "የደረሰኝ ቁጥር",
  "Invoice Date": "የደረሰኝ ቀን",
  "Invoice Details": "የደረሰኝ ዝርዝር",
  "Due Date": "የመክፈያ ቀን",
  "Payment Date": "የተከፈለበት ቀን",
  "Receipt Number": "የደረሰኝ ቁጥር",
  "Proof of Payment (Image)": "የክፍያ ማስረጃ (ምስል)",
  "Mark Invoice as Paid": "ደረሰኙን ተከፍሏል ብለው መዝግቡ",
  "Total Amount": "ጠቅላላ መጠን",
  Qty: "ብዛት",
  "Invoicing and payments": "ደረሰኝና ክፍያዎች",
  "Payment Performance": "የክፍያ አፈጻጸም",
  "Payment Due & Late Penalty": "የመክፈያ ቀንና የዘግይት ቅጣት",
  "Grace Days": "የምሕረት ቀናት",
  "Fixed amount (ETB)": "ቋሚ መጠን (ብር)",
  "Percentage (%)": "መቶኛ (%)",

  // Incidents, settings and errors
  Incident: "ክስተት",
  "Panic/Emergency": "ድንገተኛ አደጋ",
  Subject: "ርዕስ",
  "Reported By (Optional)": "ሪፖርት ያደረገው (አማራጭ)",
  "My Profile": "የእኔ መገለጫ",
  "Profile Information": "የመገለጫ መረጃ",
  "Initial Password": "የመጀመሪያ የይለፍ ቃል",
  "Access Denied": "መዳረሻ ተከልክሏል",
  "You don't have the required permissions.": "አስፈላጊው ፈቃድ የለዎትም።",
  Unauthorized: "ፈቃድ የለም",
  "Error loading salary details": "የደመወዝ ዝርዝር መጫን አልተሳካም",
  "Failed to load invoice details": "የደረሰኝ ዝርዝር መጫን አልተሳካም",
  "Client email not configured": "የደንበኛ ኢሜይል አልተዘጋጀም",
  "Invoice email not sent yet": "የደረሰኝ ኢሜይል ገና አልተላከም",
  "You have unsaved changes": "ያልተቀመጡ ለውጦች አሉዎት",

  // Search/select placeholders
  "Search asset or employee...": "ንብረት ወይም ሠራተኛ ፈልግ...",
  "Search bids...": "ጨረታዎችን ፈልግ...",
  "Search by code, name, or category...": "በኮድ፣ ስም ወይም ምድብ ፈልግ...",
  "Search by company name, contact person, or phone...":
    "በድርጅት ስም፣ ተጠሪ ወይም ስልክ ፈልግ...",
  "Search by name or employee code...": "በስም ወይም በሠራተኛ ኮድ ፈልግ...",
  "Search by name, email, or phone...": "በስም፣ ኢሜይል ወይም ስልክ ፈልግ...",
  "Search company or site...": "ድርጅት ወይም ሳይት ፈልግ...",
  "Search field staff...": "የመስክ ሠራተኛ ፈልግ...",
  "Search invoices...": "ደረሰኞችን ፈልግ...",
  "Search jobs...": "ሥራዎችን ፈልግ...",
  "Search leads...": "ደንበኞችን ፈልግ...",
  "Search users...": "ተጠቃሚዎችን ፈልግ...",
  "Select a role": "ሚና ምረጥ",
  "Select a site": "ሳይት ምረጥ",
  "Select category": "ምድብ ምረጥ",
  "Select client": "ደንበኛ ምረጥ",
  "Select company": "ድርጅት ምረጥ",
  "Select condition": "ሁኔታ ምረጥ",
  "Select employee": "ሠራተኛ ምረጥ",
  "Select job type": "የሥራ ዓይነት ምረጥ",
  "Select severity": "የክብደት ደረጃ ምረጥ",
  "Select sex": "ጾታ ምረጥ",
  "Select existing client": "ነባር ደንበኛ ምረጥ",
  "Select CRM category": "የCRM ምድብ ምረጥ",
  "Select billing cycle...": "የክፍያ ዙር ምረጥ...",
  "No client / public tender": "ደንበኛ የሌለው / የሕዝብ ጨረታ",
  "No specific site": "የተወሰነ ሳይት የለም",
  "All client sites": "ሁሉም የደንበኛ ሳይቶች",
  "All service categories": "ሁሉም የአገልግሎት ምድቦች",
  "All payment statuses": "ሁሉም የክፍያ ሁኔታዎች",
});

Object.assign(amharic, {
  "Additional payment notes or description...": "ተጨማሪ የክፍያ ማስታወሻ ወይም መግለጫ...",
  "Additional vacancy information, working conditions, benefits, location, or application instructions...":
    "ተጨማሪ የሥራ መረጃ፣ የሥራ ሁኔታ፣ ጥቅማጥቅም፣ ቦታ ወይም የማመልከቻ መመሪያ...",
  "All Categories": "ሁሉም ምድቦች",
  Assign: "መድብ",
  "Attended but late": "ተገኝቷል ግን ዘግይቷል",
  "Attended on time": "በሰዓቱ ተገኝቷል",
  "Choose a job...": "ሥራ ምረጥ...",
  "Configure overrides": "ልዩ ማስተካከያዎችን አዘጋጅ",
  "Create employee from this application": "ከዚህ ማመልከቻ ሠራተኛ ፍጠር",
  "Delete all shifts for this employee": "የዚህን ሠራተኛ ሁሉንም ፈረቃዎች ሰርዝ",
  "Delete Application": "ማመልከቻ ሰርዝ",
  "Delete assignment history": "የምደባ ታሪክ ሰርዝ",
  "Delete Category": "ምድብ ሰርዝ",
  "Delete Client": "ደንበኛ ሰርዝ",
  "Delete Document": "ሰነድ ሰርዝ",
  "Delete Incident": "ክስተት ሰርዝ",
  "Delete Job": "ሥራ ሰርዝ",
  "Delete Screening": "ማጣሪያ ሰርዝ",
  "Delete shift": "ፈረቃ ሰርዝ",
  "Delete Site": "ሳይት ሰርዝ",
  "Delete this shift": "ይህን ፈረቃ ሰርዝ",
  "Delete Vacancy": "ክፍት የሥራ ቦታ ሰርዝ",
  "Describe this client, their business, services, or important notes...":
    "ይህን ደንበኛ፣ ንግዱን፣ አገልግሎቱን ወይም ጠቃሚ ማስታወሻ ይግለጹ...",
  "Describe this site, access instructions, or important operational notes...":
    "ይህን ሳይት፣ የመግቢያ መመሪያ ወይም ጠቃሚ የኦፕሬሽን ማስታወሻ ይግለጹ...",
  "Describe what happened...": "የተከሰተውን ይግለጹ...",
  "Details...": "ዝርዝር...",
  "Did not attend": "አልተገኘም",
  "Discussion, complaint or requested action": "ውይይት፣ ቅሬታ ወይም የተጠየቀ እርምጃ",
  "Document name": "የሰነድ ስም",
  "Document name e.g. Signed agreement": "የሰነድ ስም፣ ለምሳሌ፦ የተፈረመ ስምምነት",
  "Edit Positions": "የሥራ ቦታዎችን አርትዕ",
  "Education, certifications, experience level...":
    "ትምህርት፣ ማረጋገጫዎች፣ የልምድ ደረጃ...",
  "Enter amount (positive to add, negative to deduct)":
    "መጠን ያስገቡ (ለመጨመር አዎንታዊ፣ ለመቀነስ አሉታዊ)",
  "Enter reason for permission (e.g., 'Sick leave', 'Personal matter')":
    "የፈቃድ ምክንያት ያስገቡ (ለምሳሌ፦ ሕመም፣ የግል ጉዳይ)",
  "Enter reason for this adjustment": "የዚህን ማስተካከያ ምክንያት ያስገቡ",
  "Enter reporter name...": "የሪፖርት አድራጊውን ስም ያስገቡ...",
  "Enter your email": "ኢሜይልዎን ያስገቡ",
  "Enter your email or username": "ኢሜይል ወይም የተጠቃሚ ስም ያስገቡ",
  "Enter your password": "የይለፍ ቃልዎን ያስገቡ",
  "First name": "የመጀመሪያ ስም",
  "Future shift": "የወደፊት ፈረቃ",
  "Issue subject": "የጉዳይ ርዕስ",
  "Item description": "የንጥል መግለጫ",
  "Job description...": "የሥራ መግለጫ...",
  "Last name": "የአባት ስም",
  "Manage Skills": "ክህሎቶችን አስተዳድር",
  "Name…": "ስም…",
  "New category e.g. Security Guard": "አዲስ ምድብ፣ ለምሳሌ፦ የደህንነት ጥበቃ",
  "Open screening for this application": "የዚህን ማመልከቻ ማጣሪያ ክፈት",
  "Optional description...": "አማራጭ መግለጫ...",
  "Referral, LinkedIn, Website, etc.": "ሪፈራል፣ LinkedIn፣ ድረ ገጽ፣ ወዘተ",
  "Remove Job": "ሥራ አስወግድ",
  Return: "መልስ",
  Score: "ውጤት",
  "Select type": "ዓይነት ምረጥ",
  "Select vacancy (optional)": "ክፍት የሥራ ቦታ ምረጥ (አማራጭ)",
  "Short notes about interview / exam result...":
    "ስለ ቃለ መጠይቅ / ፈተና ውጤት አጭር ማስታወሻ...",
  "Skills, experience, and other requirements (brief note)...":
    "ክህሎቶች፣ ልምድና ሌሎች መስፈርቶች (አጭር ማስታወሻ)...",
  "Total vehicle rental cost": "ጠቅላላ የተሽከርካሪ ኪራይ ወጪ",
  "View Details": "ዝርዝር ተመልከት",
  "View Salary History": "የደመወዝ ታሪክ ተመልከት",
  "vs last month": "ከባለፈው ወር ጋር",
  "vs last week": "ካለፈው ሳምንት ጋር",
  "Work experience, years, and key responsibilities...":
    "የሥራ ልምድ፣ ዓመታትና ዋና ኃላፊነቶች...",
});

Object.assign(amharic, {
  "Absent (N)": "ቀሪ (ያለፈቃድ)",
  "Absent (P)": "ቀሪ (በፈቃድ)",
  "Absent Penalty (ETB)": "የቀሪ ቅጣት (ብር)",
  "Accepted: XLSX, XLS, or CSV. Maximum 10 MB.":
    "የሚፈቀዱ፦ XLSX፣ XLS ወይም CSV። ከፍተኛው 10 MB።",
  "Add Document": "ሰነድ ጨምር",
  "Add Job Requirement": "የሥራ መስፈርት ጨምር",
  "Add jobs to define staffing needs.": "የሠራተኛ ፍላጎትን ለመወሰን ሥራዎችን ይጨምሩ።",
  "Agcy Fee": "የኤጀንሲ ክፍያ",
  "Agency Fee %": "የኤጀንሲ ክፍያ %",
  "All Jobs": "ሁሉም ሥራዎች",
  "Amount / Payment": "መጠን / ክፍያ",
  "Apply again for every overdue month": "በእያንዳንዱ የዘገየ ወር እንደገና ተግብር",
  "Asset Deductions": "የንብረት ቅናሾች",
  "Attachments (Proofs, Installments, Penalty Docs)":
    "አባሪዎች (ማስረጃ፣ ክፍለ ክፍያ፣ የቅጣት ሰነዶች)",
  "Base Salary (ETB)": "መሠረታዊ ደመወዝ (ብር)",
  Bonus: "ጉርሻ",
  "Capture basic details about the potential client.":
    "ስለ እምቅ ደንበኛው መሠረታዊ መረጃ ይመዝግቡ።",
  "Category Code": "የምድብ ኮድ",
  "Category Name": "የምድብ ስም",
  'Click "Generate Payroll" to calculate.': "ለማስላት “ደመወዝ አስላ”ን ይጫኑ።",
  "Client / Site": "ደንበኛ / ሳይት",
  "Client pays by (calendar)": "ደንበኛው የሚከፍልበት (የቀን መቁጠሪያ)",
  "Clocked out &lt; 15 min": "ከ15 ደቂቃ በታች ቀድሞ ወጥቷል",
  "Company / Site": "ድርጅት / ሳይት",
  "Configure which days employees work and their specific hours":
    "ሠራተኞች የሚሠሩባቸውን ቀናትና ሰዓታት ያዘጋጁ",
  "Confirm New Password": "አዲሱን የይለፍ ቃል አረጋግጥ",
  Contact: "ተጠሪ",
  "Contains the reusable Excel template, a full English PDF guide, and a full Amharic PDF guide.":
    "ዳግም ጥቅም ላይ የሚውል የExcel አብነት፣ ሙሉ የእንግሊዝኛ PDF መመሪያ እና ሙሉ የአማርኛ PDF መመሪያ ይዟል።",
  "Create categories used by contracts and bids, or change their active state.":
    "በውሎችና ጨረታዎች የሚጠቀሙ ምድቦችን ይፍጠሩ ወይም ንቁነታቸውን ይቀይሩ።",
  "Create GPS attendance shifts. Existing overlapping shifts are skipped.":
    "የGPS መገኘት ፈረቃዎችን ይፍጠሩ። የሚደራረቡ ነባር ፈረቃዎች ይታለፋሉ።",
  "Create Period": "ጊዜ ፍጠር",
  Custom: "ብጁ",
  "Dates on invoices for this client will be shown in this calendar.":
    "የዚህ ደንበኛ የደረሰኝ ቀናት በዚህ የቀን መቁጠሪያ ይታያሉ።",
  Days: "ቀናት",
  "Days allowed after the due date before penalty starts.":
    "ቅጣት ከመጀመሩ በፊት ከመክፈያ ቀን በኋላ የሚፈቀዱ ቀናት።",
  "Description / Requirements": "መግለጫ / መስፈርቶች",
  "Detailed Breakdown": "ዝርዝር ክፍፍል",
  "Download and use the standard ZIP package if this file has different columns or formatting.":
    "ይህ ፋይል የተለየ ዓምድ ወይም ቅርጸት ካለው መደበኛውን ZIP ጥቅል አውርደው ይጠቀሙ።",
  Duration: "ቆይታ",
  "Duration:": "ቆይታ፦",
  "Email / Username": "ኢሜይል / የተጠቃሚ ስም",
  "Email Address": "ኢሜይል አድራሻ",
  End: "መጨረሻ",
  "End time": "መጨረሻ ሰዓት",
  "Estimated Value (ETB)": "የተገመተ ዋጋ (ብር)",
  "Example: 10% becomes 20% after two overdue months. Turn off to charge only once.":
    "ምሳሌ፦ 10% ከሁለት የዘገዩ ወራት በኋላ 20% ይሆናል። አንድ ጊዜ ብቻ ለማስከፈል ያጥፉት።",
  Expected: "የሚጠበቅ",
  "GM (Admin)": "ዋና ሥራ አስኪያጅ (አስተዳዳሪ)",
  "Google Maps API Key Required": "የGoogle Maps API ቁልፍ ያስፈልጋል",
  "Hold Ctrl/Cmd to select multiple employees":
    "ብዙ ሠራተኞችን ለመምረጥ Ctrl/Cmdን ተጭነው ይያዙ",
  "Hourly Rate (ETB)": "የሰዓት ክፍያ (ብር)",
  HR: "የሰው ኃይል",
  "Import manual, GPS, or mixed attendance with row-level validation and safe updates.":
    "በእጅ፣ GPS ወይም ድብልቅ መገኘትን ከእያንዳንዱ ረድፍ ማረጋገጫና ደህንነቱ የተጠበቀ ማዘመን ጋር ያስገቡ።",
  "Important:": "አስፈላጊ፦",
  "In Progress": "በሂደት ላይ",
  Issues: "ጉዳዮች",
  "Job Title (AM)": "የሥራ መደብ (አማ)",
  "Job Title (Amharic)": "የሥራ መደብ (አማርኛ)",
  "Job Title (EN)": "የሥራ መደብ (እንግ)",
  "Job Title (English)": "የሥራ መደብ (እንግሊዝኛ)",
  "Jobs Count": "የሥራዎች ብዛት",
  "Last processed": "መጨረሻ የተከናወነው",
  "Lat:": "ኬክሮስ፦",
  "Late (N)": "ዘግይቷል (ያለፈቃድ)",
  "Late (P)": "ዘግይቷል (በፈቃድ)",
  "Late Arrival": "ዘግይቶ መድረስ",
  "Late Penalty (ETB)": "የዘግይት ቅጣት (ብር)",
  "Late Penalty Type": "የዘግይት ቅጣት ዓይነት",
  "List of all pending and applied penalties.":
    "በመጠባበቅ ላይ ያሉና የተተገበሩ ቅጣቶች ዝርዝር።",
  "List of all pending and processed bonuses.":
    "በመጠባበቅ ላይ ያሉና የተከናወኑ ጉርሻዎች ዝርዝር።",
  "Lng:": "ኬንትሮስ፦",
  "Loading current setting…": "የአሁኑ ቅንብር በመጫን ላይ…",
  "Loading job requirements...": "የሥራ መስፈርቶች በመጫን ላይ...",
  "Loading reports...": "ሪፖርቶች በመጫን ላይ...",
  "Loading sites...": "ሳይቶች በመጫን ላይ...",
  "Loading upcoming shifts...": "መጪ ፈረቃዎች በመጫን ላይ...",
  "Manage disciplinary penalties and deductions.":
    "የሥነ ምግባር ቅጣቶችንና ቅናሾችን ያስተዳድሩ።",
  "Manage job types, rates, and requirements":
    "የሥራ ዓይነቶችን፣ ክፍያዎችንና መስፈርቶችን ያስተዳድሩ",
  "Manage performance bonuses and one-time payments.":
    "የአፈጻጸም ጉርሻዎችንና የአንድ ጊዜ ክፍያዎችን ያስተዳድሩ።",
  "Manual Penalty": "በእጅ ቅጣት",
  Marketing: "ግብይት",
  "Monitor assigned site controllers, GPS verification, late arrivals and clock-outs.":
    "የተመደቡ የሳይት ተቆጣጣሪዎችን፣ GPS ማረጋገጫን፣ ዘግይቶ መድረስንና መውጫን ይከታተሉ።",
  "Name of applicant": "የአመልካች ስም",
  "New Skill Name": "የአዲስ ክህሎት ስም",
  "No Field Staff are assigned to this site. Assign a site from User Management first.":
    "ለዚህ ሳይት የተመደበ የመስክ ሠራተኛ የለም። መጀመሪያ ከተጠቃሚ አስተዳደር ሳይት ይመድቡ።",
  "No field staff found": "የመስክ ሠራተኛ አልተገኘም",
  "No jobs linked": "የተያያዘ ሥራ የለም",
  "No late penalty applies on this invoice date.":
    "በዚህ የደረሰኝ ቀን የዘግይት ቅጣት አይተገበርም።",
  "No penalty": "ቅጣት የለም",
  "No salary history found": "የደመወዝ ታሪክ አልተገኘም",
  "No sites found": "ሳይት አልተገኘም",
  "No verification image was uploaded for this attendance record. Images are optional for employees and Field Staff.":
    "ለዚህ የመገኘት መዝገብ የማረጋገጫ ምስል አልተሰቀለም። ምስሎች ለሠራተኞችና የመስክ ሠራተኞች አማራጭ ናቸው።",
  "Not attached": "አልተያያዘም",
  "Not finished (under 95% of shift)": "አልተጠናቀቀም (ከፈረቃው 95% በታች)",
  "Note:": "ማስታወሻ፦",
  Operations: "ኦፕሬሽንስ",
  "Organize jobs into categories (e.g., Security, Hospitality)":
    "ሥራዎችን በምድብ ያደራጁ (ለምሳሌ፦ ደህንነት፣ መስተንግዶ)",
  Other: "ሌላ",
  "Other Ded.": "ሌላ ቅናሽ",
  Overrides: "ልዩ ማስተካከያዎች",
  "Overtime Multiplier": "የትርፍ ሰዓት ማባዣ",
  "Owner (Super Admin)": "ባለቤት (ዋና አስተዳዳሪ)",
  "P?": "ፈቃድ?",
  "Pay rates will be determined by job settings": "የክፍያ መጠን በሥራ ቅንብሮች ይወሰናል",
  "Payment Day (1–31)": "የክፍያ ቀን (1–31)",
  Penalties: "ቅጣቶች",
  "Penalty for absence with permission": "በፈቃድ ለመቅረት ቅጣት",
  "Penalty for late arrival with permission": "በፈቃድ ዘግይቶ ለመድረስ ቅጣት",
  Period: "ጊዜ",
  "Permission Absent Penalty (ETB)": "የፈቃድ ቀሪ ቅጣት (ብር)",
  "Permission Late Penalty (ETB)": "የፈቃድ ዘግይት ቅጣት (ብር)",
  Practical: "ተግባራዊ",
  "Practical Exam Vehicle Rental (ETB)": "የተግባር ፈተና ተሽከርካሪ ኪራይ (ብር)",
  Probation: "የሙከራ ጊዜ",
  "Processed Date": "የተከናወነበት ቀን",
  Procurement: "ግዢ",
  Reason: "ምክንያት",
  "Record and manage employee attendance": "የሠራተኛ መገኘትን ይመዝግቡና ያስተዳድሩ",
  "Reference #": "ማጣቀሻ ቁጥር",
  Result: "ውጤት",
  "Search Employee": "ሠራተኛ ፈልግ",
  "Select a job...": "ሥራ ምረጥ...",
  "Select a payroll period to view details": "ዝርዝር ለማየት የደመወዝ ጊዜ ምረጥ",
  "Select a site first.": "መጀመሪያ ሳይት ምረጥ።",
  "Select Job": "ሥራ ምረጥ",
  "Select one or more staff members responsible for this site.":
    "ለዚህ ሳይት ኃላፊ የሆኑ አንድ ወይም ብዙ ሠራተኞችን ምረጥ።",
  "Select site": "ሳይት ምረጥ",
  "Sent/Due": "የተላከ / የሚከፈል",
  "Set as primary job": "እንደ ዋና ሥራ አድርግ",
  "Set start and end dates and select client for the new payroll period.":
    "ለአዲሱ የደመወዝ ጊዜ መጀመሪያና መጨረሻ ቀን ያስገቡ እና ደንበኛ ይምረጡ።",
  "Set the monthly payment day, grace period, and overdue charge.":
    "ወርሃዊ የክፍያ ቀን፣ የምሕረት ጊዜና የዘግይት ቅጣት ያዘጋጁ።",
  "Site Contact Phone": "የሳይት ተጠሪ ስልክ",
  Sites: "ሳይቶች",
  "Staff Portal": "የሠራተኞች ፖርታል",
  Start: "መጀመሪያ",
  "Tax %": "ግብር %",
  "TIN Number": "የቲን ቁጥር",
  Title: "ርዕስ",
  "Total Gross (YTD)": "ጠቅላላ ገቢ (ከዓመቱ መጀመሪያ)",
  "Total Hours": "ጠቅላላ ሰዓታት",
  "Track new customers before they become registered clients.":
    "አዲስ ደንበኞች ከመመዝገባቸው በፊት ይከታተሉ።",
  Type: "ዓይነት",
  "Update Positions Needed": "የሚፈለጉ የሥራ ቦታዎችን አዘምን",
  "Upload scheduled employee attendance in bulk. Every row is processed independently, so errors never stop valid rows.":
    "የታቀደ የሠራተኛ መገኘትን በጅምላ ይስቀሉ። እያንዳንዱ ረድፍ በተናጠል ስለሚከናወን ስህተቶች ትክክለኛ ረድፎችን አያቆሙም።",
  Uploaded: "ተሰቅሏል",
  "Used if advanced schedule is disabled": "የላቀ መርሃ ግብ ከተሰናከለ ጥቅም ላይ ይውላል",
  Vacancy: "ክፍት የሥራ ቦታ",
  "Valid Until": "የሚያገለግልበት እስከ",
  Validity: "የቆይታ ጊዜ",
  "View Full Image (Opens in new tab)": "ሙሉ ምስል ተመልከት (በአዲስ ትር ይከፈታል)",
  Written: "የጽሑፍ",
  "Manual Only": "በእጅ ብቻ",
  "Agents & supervisors fill attendance": "ወኪሎችና ተቆጣጣሪዎች መገኘትን ይመዘግባሉ",
  "Attendance is entered manually by agents (HQ) or site supervisors. The GPS / Telegram clock-in system is still available but not the primary method.": "መገኘት በዋና መሥሪያ ቤት ወኪሎች ወይም በሳይት ተቆጣጣሪዎች በእጅ ይመዘገባል። የGPS / Telegram መግቢያ ሥርዓት አሁንም ይገኛል፣ ግን ዋናው ዘዴ አይደለም።",
  "Default tab on Attendance page → Manual Entry": "በመገኘት ገጽ ላይ ነባሪ ትር → በእጅ ማስገቢያ",
  "Agents pick date, see all shifts, mark Present / Late / Absent": "ወኪሎች ቀን መርጠው ሁሉንም ፈረቃዎች ያያሉ፣ ተገኝቷል / ዘግይቷል / ቀርቷል ብለው ይመዘግባሉ",
  "Supervisors can only manage their assigned sites": "ተቆጣጣሪዎች የተመደቡባቸውን ሳይቶች ብቻ ማስተዳደር ይችላሉ",
  "GPS entries still appear in the Logs tab if any come in": "የGPS መዝገቦች ካሉ በመዝገቦች ትር ውስጥ ይታያሉ",
  Mixed: "ድብልቅ",
  "GPS primary, manual fills the gaps": "GPS ዋና ሲሆን በእጅ የጎደለውን ይሞላል",
  "Employees who use the Telegram bot or member portal clock in via GPS. Agents and supervisors use manual entry to fill any missing or incorrect records.": "Telegram bot ወይም የአባላት ፖርታል የሚጠቀሙ ሠራተኞች በGPS ይገባሉ። ወኪሎችና ተቆጣጣሪዎች የጎደሉ ወይም የተሳሳቱ መዝገቦችን በእጅ ያስተካክላሉ።",
  "Both Manual Entry and Logs tabs equally visible": "በእጅ ማስገቢያና መዝገቦች ትሮች እኩል ይታያሉ",
  "GPS-recorded entries shown in Logs tab": "በGPS የተመዘገቡ ግቤቶች በመዝገቦች ትር ይታያሉ",
  "Manual entry used for corrections and missing entries": "በእጅ ማስገቢያ ለእርማትና ለጎደሉ መዝገቦች ይጠቅማል",
  "Best for a transition period": "ለሽግግር ጊዜ ተስማሚ",
  "Full GPS": "ሙሉ GPS",
  "Employees clock in via Telegram / app": "ሠራተኞች በTelegram / መተግበሪያ ይገባሉ",
  "All employees use the Telegram bot or member portal to clock in and out with GPS verification. Manual entry is still available for emergencies and corrections.": "ሁሉም ሠራተኞች በGPS ማረጋገጫ ለመግባትና ለመውጣት Telegram bot ወይም የአባላት ፖርታልን ይጠቀማሉ። በእጅ ማስገቢያ ለአደጋ ጊዜና ለእርማት ይገኛል።",
  "Default tab on Attendance page → Logs (GPS records)": "በመገኘት ገጽ ላይ ነባሪ ትር → መዝገቦች (የGPS መዝገቦች)",
  "Real-time GPS verification at the work site": "በሥራ ሳይት ላይ ቅጽበታዊ የGPS ማረጋገጫ",
  "Manual entry tab available as a fallback for corrections": "የእርማት አማራጭ ሆኖ በእጅ ማስገቢያ ትር ይገኛል",
  "Best for fully digitised teams": "ሙሉ ዲጂታል ለሆኑ ቡድኖች ተስማሚ",
  Selected: "የተመረጠ",
  "Choose how attendance is recorded across the system. This setting affects all agents, supervisors, and the default view on the Attendance page.": "በሥርዓቱ ውስጥ መገኘት እንዴት እንደሚመዘገብ ይምረጡ። ይህ ቅንብር ሁሉንም ወኪሎች፣ ተቆጣጣሪዎችና የመገኘት ገጹን ነባሪ እይታ ይነካል።",
  "Changing the mode takes effect immediately for all users. GPS clock-in endpoints are always available regardless of mode — this setting only controls the default view and workflow guidance shown to agents and supervisors.": "ሁነታውን መቀየር ለሁሉም ተጠቃሚዎች ወዲያውኑ ይሠራል። የGPS መግቢያ አገልግሎቶች ሁልጊዜ ይገኛሉ፤ ይህ ቅንብር ለወኪሎችና ተቆጣጣሪዎች የሚታየውን ነባሪ እይታና የሥራ ፍሰት መመሪያ ብቻ ይቆጣጠራል።",
  "Saving…": "በማስቀመጥ ላይ…",
  "✓ Saved": "✓ ተቀምጧል",
  "Import Excel": "ከExcel አስገባ",
  "Import Employees from Excel or CSV": "ሠራተኞችን ከExcel ወይም CSV አስገባ",
  "Create or safely update employees in bulk with Ethiopian/Gregorian dates, exact row validation, and a result for every row.": "ሠራተኞችን በጅምላ በኢትዮጵያ/ጎርጎርዮሳዊ ቀን፣ በየረድፉ ማረጋገጫ በደህንነት ይፍጠሩ ወይም ያዘምኑ።",
  "Register employees in bulk with Ethiopian/Gregorian date conversion, duplicate protection, and a result for every row.":
    "ሠራተኞችን በጅምላ ከኢትዮጵያ/ጎርጎርዮሳዊ ቀን ቅየራ፣ ድግግሞሽ መከላከያና የየረድፉ ውጤት ጋር ያስገቡ።",
  "1. Download the reusable package": "1. እንደገና የሚጠቀሙበትን ጥቅል ያውርዱ",
  "Includes the branded Excel template plus complete English and Amharic PDF instructions.":
    "የብራንድ Excel ቅጽ እና ሙሉ የእንግሊዝኛ/አማርኛ PDF መመሪያዎችን ያካትታል።",
  "Download Template + PDF Guides (.zip)": "Template + PDF መመሪያዎችን አውርድ (.zip)",
  "2. Choose defaults and upload": "2. ነባሪ ምርጫዎችን መርጠው ይስቀሉ",
  "Blank category/calendar cells use these selections. A value inside the file overrides the default.":
    "ባዶ category/calendar ሴሎች እነዚህን ምርጫዎች ይጠቀማሉ። በፋይሉ ውስጥ ያለ ዋጋ ነባሪውን ይተካል።",
  "Default employee category": "ነባሪ የሠራተኛ ምድብ",
  "Dates in this file": "በዚህ ፋይል ያሉ ቀናት",
  "Ethiopian Calendar (EC)": "የኢትዮጵያ ዘመን አቆጣጠር (EC)",
  "Gregorian Calendar (GC)": "የጎርጎርዮሳዊ ዘመን አቆጣጠር (GC)",
  "Choose Excel or CSV File": "Excel ወይም CSV ፋይል ይምረጡ",
  "Change File": "ፋይል ቀይር",
  "Import Employees": "ሠራተኞችን አስገባ",
  "Processing every employee…": "እያንዳንዱን ሠራተኛ በማስኬድ ላይ…",
  "Import failed": "ኢምፖርት አልተሳካም",
  "Employee import completed": "የሠራተኛ ኢምፖርት ተጠናቋል",
  "Employee import completed with errors": "የሠራተኛ ኢምፖርት ከስህተቶች ጋር ተጠናቋል",
  "Row-by-row import report": "የየረድፉ ኢምፖርት ሪፖርት",
  "Excel Row": "የExcel ረድፍ",
  "Details / Initial Password": "ዝርዝር / የመጀመሪያ የይለፍ ቃል",
  "Details / Changes": "ዝርዝር / ለውጦች",
  "Error Column": "የስህተት አምድ",
  Created: "ተፈጥሯል",
  Updated: "ተዘምኗል",
  Unchanged: "አልተቀየረም",
  Duplicates: "የተደገሙ",
  Errors: "ስህተቶች",
  "Empty skipped": "ባዶ የታለፉ",
  "Employee selection": "የሠራተኛ ምርጫ",
  "Search name, ID, phone, work, or skill…": "በስም፣ መለያ፣ ስልክ፣ ሥራ ወይም ክህሎት ፈልግ…",
  "All assigned jobs": "ሁሉም የተመደቡ ሥራዎች",
  "Clear visible": "የሚታዩትን አጽዳ",
  "Clear all": "ሁሉንም አጽዳ",
  "Loading active employees…": "ንቁ ሠራተኞችን በመጫን ላይ…",
  "No employees match these filters": "ከእነዚህ ማጣሪያዎች ጋር የሚዛመድ ሠራተኛ የለም",
  "Reset employee filters": "የሠራተኛ ማጣሪያዎችን ዳግም አስጀምር",
  "Not qualified": "ብቁ አይደለም",
  "Category match · job linked on assign": "ምድቡ ይዛመዳል · ሲመደብ ሥራው ይገናኛል",
  "Skills": "ክህሎቶች",
  "Select the Job Type above first. The system will then show qualified employees and prevent incompatible assignments.": "በመጀመሪያ ከላይ የሥራ ዓይነትን ይምረጡ። ሲስተሙ ብቁ ሠራተኞችን ያሳያል እና የማይጣጣሙ ምደባዎችን ይከላከላል።",
  "Pay rates use job settings. Only employees assigned to this job can be selected.": "የክፍያ መጠኖች የሥራ ቅንብሮችን ይጠቀማሉ። ለዚህ ሥራ የተመደቡ ሠራተኞች ብቻ ሊመረጡ ይችላሉ።",
  "You don&apos;t have the required permissions.": "አስፈላጊው ፈቃድ የለዎትም።",
});

export const translateStatic = (text: string, language: StaffLanguage) => {
  if (language !== "am") return text;
  if (amharic[text]) return amharic[text];
  const suffixes = [" *", " (Optional)", " (optional)", ":"];
  for (const suffix of suffixes) {
    if (text.endsWith(suffix)) {
      const base = text.slice(0, -suffix.length);
      if (amharic[base]) return `${amharic[base]}${suffix}`;
    }
  }
  return text;
};
